/// <reference path="/js/lib/jquery/jquery-1.9.1.js"/>
/// <reference path="/js/lib/backbone.js"/>
/// <reference path="BaseSelectorView.js"/>

(function($, _) {
  var ns = window.nspace("ccc.viz.selectors");

  ns.MultipleDataTypeSelectorView = ns.BaseSelectorView.extend({
    name: "Multiple Data Type Selector",
    el: "#multiple-data-type-selector",
    templateSelector: "#multiple-data-type-selector-template",
    propertyName: "dataTypeIds",

    initialize: function(options) {
      _.bindAll(this);

      this.getSelectorInfoFunc = options.getSelectorInfoFunc;
    },

    events: {
      change: "onChangeUpdateModel"
    },

    onChangeUpdateModel: function() {
      var $allCheckboxes, $checkedCheckboxes, checkboxValues;

      $allCheckboxes = this.$("input:checkbox");
      $checkedCheckboxes = $allCheckboxes.filter(":checked");

      if ($allCheckboxes.length === $checkedCheckboxes.length) {
        checkboxValues = ["a"];
      }
      else {
        // Update the model
        checkboxValues = $checkedCheckboxes
          .map(function() {
            return this.value;
          })
          .get();
      }

      this.model.set(this.propertyName, checkboxValues);
    },

    initializeModel: function() {
      // Update the model with all of the available checkboxes.
      this.model.set(this.propertyName, ["a"], { silent: true });
    },

    /**
     * Returns text summarizing the currently selected options for this selector.
     */
    getDataSummaryText: function() {
      var dataFormats;

      dataFormats = this.model.get(this.propertyName);

      if (dataFormats[0] === "a") {
        return "All Data Types";
      }

      if (!dataFormats.length) {
        return "No Data Types Selected";
      }

      if (dataFormats.length === 1) {
        return this.$("input[value=" + dataFormats[0] + "]").data("name");
      }

      return dataFormats.length + " Data Types";
    },

    updateDOM: function() {
      var dataFormats;

      dataFormats = this.model.get(this.propertyName);

      if (dataFormats[0] === "a") {
        this.$("input").prop("checked", true);
        return;
      }

      this.$("input").each(function() {
        var $self, shouldBeChecked;

        $self = $(this);
        shouldBeChecked = _.any(dataFormats, function(dataFormat) {
          return +$self.val() === +dataFormat;
        });
        $self.prop("checked", shouldBeChecked);
      });
    }
  });
})(jQuery, _);
